import React, { Component } from 'react';
import fire from './fire';
import logo from './logo.svg';
import './App.css';
import 'bulma/css/bulma.css'

import ReactGA from 'react-ga';
import firebase from 'firebase';
import { provider, auth } from './fire';

import AREntry from './components/arEntry';
import AREntryTile from './components/arEntryTile';
import AREntryTiles from './components/arEntryTiles';
import ToggleView from './components/toggleView';
import ToggleButton from './components/toggleButton';
import ExhibitionEntry from './components/exhibitionEntry';
import Map from './components/map';
import EntryInfo from './components/entryInfo';

ReactGA.initialize('UA-124593667-1');
ReactGA.pageview(window.location.pathname + window.location.search);

const data = [
  {
    imageSrc: "/images/scene_02.png",
    city: "Vienna",
    country: "Austria",
    location: "MUMOK Schedule Board",
    locationUrl: "https://goo.gl/maps/p3it8kBKQJ92",
    effectUrl: "http://bit.ly/2LiSy3s",
    shareUrl: "https%3A%2F%2Fwww.facebook.com%2Ffbcameraeffects%2Ftryit%2F313428082559650%2F",
    lat: 48.2038,
    lng: 16.3578
  },
  {
    imageSrc: "/images/scene_01.png",
    city: "Vienna",
    country: "Austria",
    location: "Kunsthalle, Museumsquartier",
    locationUrl: "https://goo.gl/maps/1b1EhjHtyhq",
    effectUrl: "http://bit.ly/2OcbL4G",
    shareUrl: "https%3A%2F%2Fwww.facebook.com%2Ffbcameraeffects%2Ftryit%2F206877830007632%2F",
    lat: 48.2031,
    lng: 16.3578
  },
  {
    imageSrc: "/images/scene_04.png",
    city: "Vienna",
    country: "Austria",
    location: "Goethe Memorial Statue",
    locationUrl: "https://goo.gl/maps/4fsUTjhbDhH2",
    effectUrl: "http://bit.ly/2OgTjrK",
    shareUrl: "https%3A%2F%2Fwww.facebook.com%2Ffbcameraeffects%2Ftryit%2F1050955498362830%2F",
    lat: 48.2033145,
    lng: 16.3659214
  },
  {
    imageSrc: "/images/scene_03.png",
    city: "Vienna",
    country: "Austria",
    location: "Pink Rabbit",
    locationUrl: "https://goo.gl/maps/AfdNfrxYysM2",
    effectUrl: "http://bit.ly/2v0LBJv",
    shareUrl: "https%3A%2F%2Fwww.facebook.com%2Ffbcameraeffects%2Ftryit%2F428817790941328%2F",
    lat: 48.202887,
    lng: 16.368189
  },
  {
    imageSrc: "/images/scene_placeholder.png",
    city: "Nashville",
    country: "USA",
    location: "Nashville Business Poster",
    locationUrl: "https://goo.gl/maps/HK7pWMC97Ks",
    effectUrl: "http://bit.ly/2v0LBJv",
    shareUrl: "https%3A%2F%2Fwww.facebook.com%2Ffbcameraeffects%2Ftryit%2F428817790941328%2F",
    lat: 36.1868683,
    lng: -87.0654378
  },
  {
    imageSrc: "/images/scene_placeholder.png",
    city: "Sacramento",
    country: "USA",
    location: "Sacramento Business Poster",
    locationUrl: "https://goo.gl/maps/7BBUAX3GdH32",
    effectUrl: "http://bit.ly/2v0LBJv",
    shareUrl: "https%3A%2F%2Fwww.facebook.com%2Ffbcameraeffects%2Ftryit%2F428817790941328%2F",
    lat: 38.5617255,
    lng: -121.5829981
  },
  {
    imageSrc: "/images/scene_gardensbythebay.png",
    city: "Singapore",
    country: "Singapore",
    location: "Gardens by the Bay",
    locationUrl: "https://goo.gl/maps/Fr9VekpKDYG2",
    effectUrl: "http://bit.ly/2v0LBJv",
    shareUrl: "https%3A%2F%2Fwww.facebook.com%2Ffbcameraeffects%2Ftryit%2F428817790941328%2F",
    lat: 1.3143394,
    lng: 103.7041621
  },
  {
    imageSrc: "/images/scene_clarionalley.png",
    city: "San Francisco",
    country: "USA",
    location: "Mission, Clarion Alley Mural",
    locationUrl: "https://goo.gl/maps/12UP4nRH89p",
    effectUrl: "http://bit.ly/2v0LBJv",
    shareUrl: "https%3A%2F%2Fwww.facebook.com%2Ffbcameraeffects%2Ftryit%2F428817790941328%2F",
    lat: 37.763026,
    lng: -122.419926
  },
  {
    imageSrc: "/images/scene_sf_palace_fine_arts.png",
    city: "San Francisco",
    country: "USA",
    location: "Palace of Fine Arts Theatre",
    locationUrl: "https://goo.gl/maps/CWEDH7nqp3A2",
    effectUrl: "http://bit.ly/2v0LBJv",
    shareUrl: "https%3A%2F%2Fwww.facebook.com%2Ffbcameraeffects%2Ftryit%2F428817790941328%2F",
    lat: 37.8029577,
    lng: -122.4491929
  },
  {
    imageSrc: "/images/scene_brooklyn_bridge.png",
    city: "New York",
    country: "USA",
    location: "Brooklyn Bridge",
    locationUrl: "https://goo.gl/maps/ZxSgcyiZBfM2",
    effectUrl: "http://bit.ly/2v0LBJv",
    shareUrl: "https%3A%2F%2Fwww.facebook.com%2Ffbcameraeffects%2Ftryit%2F428817790941328%2F",
    lat: 40.7058134,
    lng: -73.9981622
  },
  {
    imageSrc: "/images/scene_brandenburgertor.png",
    city: "Berlin",
    country: "Germany",
    location: "Brandenburger Tor",
    locationUrl: "https://goo.gl/maps/g3wtcjTbdn32",
    effectUrl: "http://bit.ly/2LiSy3s",
    shareUrl: "https%3A%2F%2Fwww.facebook.com%2Ffbcameraeffects%2Ftryit%2F428817790941328%2F",
    lat: 52.5162746,
    lng: 13.3755154
  },
  {
    imageSrc: "/images/scene_arcdetriomphe.png",
    city: "Paris",
    country: "France",
    location: "Arc de Triomphe",
    locationUrl: "https://goo.gl/maps/N83M3N62Fy72",
    effectUrl: "http://bit.ly/2LiSy3s",
    shareUrl: "https%3A%2F%2Fwww.facebook.com%2Ffbcameraeffects%2Ftryit%2F428817790941328%2F",
    lat: 48.8702018,
    lng: 2.2751959
  }
];

const dataExhibitions = [
  {
    imageSrc: "/images/exhibition_momar.png",
    name: "MoMAR",
    city: "New York",
    country: "USA",
    location: "MoMA, Fl. 5, Jackson Pollock Room",
    locationUrl: "https://goo.gl/maps/HPSu2nkRQY82",
    eventUrl: "http://momar.gallery/",
    date: "Jun 1-Sep 6, 2018"
  },
  {
    imageSrc: "/images/exhibition_placeholder.png",
    name: "VR/AR/MR World",
    city: "Tokyo",
    country: "Japan",
    location: "Tokyo Big Sight",
    locationUrl: "https://goo.gl/maps/ftbDVrZwpZB2",
    eventUrl: "http://www.ct-next.jp/en/",
    date: "Apr 3-5, 2019"
  },
  {
    imageSrc: "/images/exhibition_oxymoron.png",
    name: "Open Call: Realities",
    city: "Vienna",
    country: "Austria",
    location: "Oxymoron",
    locationUrl: "https://goo.gl/maps/aa81zstmt3S2",
    eventUrl: "https://www.facebook.com/events/222941238338613/",
    date: "Aug 18, 2018"
  },
  {
    imageSrc: "/images/exhibition_agenda2020.png",
    name: "Agenda 2020",
    city: "London",
    country: "UK",
    location: "Hoxton Arches",
    locationUrl: "https://goo.gl/maps/1mQa2c8hhMn",
    eventUrl: "https://billetto.co.uk/e/agenda-2020-tickets-298780",
    date: "Jul 26, 2018"
  },
  {
    imageSrc: "/images/exhibition_species.png",
    name: "Felice Grodin: Invasive Species",
    city: "Miami",
    country: "USA",
    location: "Pérez Art Museum Miami",
    locationUrl: "https://goo.gl/maps/fVNiCuhYYiR2",
    eventUrl: "http://pamm.org/ar",
    date: "Dec 5, 2017–Jan 1, 2019"
  },
  {
    imageSrc: "/images/exhibition_heist.png",
    name: "Hacking the Heist",
    city: "Boston",
    country: "USA",
    location: "Isabella Stewart Gardner Museum",
    locationUrl: "https://goo.gl/maps/5T8bdiJUZcB2",
    eventUrl: "https://www.hackingtheheist.com/",
    date: "Mar 18, 2018"
  },
  {
    imageSrc: "/images/exhibition_moma.png",
    name: "WeARinMoMA",
    city: "New York",
    country: "USA",
    location: "MoMA, Fl. 1-6, Virtual Fl. 7, Garden",
    locationUrl: "https://goo.gl/maps/HPSu2nkRQY82",
    eventUrl: "http://sndrv.nl/moma/",
    date: "Oct 9, 2010"
  }
];

class App extends Component {

  state = {
    user: null,
    showGrid: false,
  }

  login = () => {
    auth().signInWithPopup(provider)
      .then(({ user }) => {
        this.setState({ user })
      })
  }

  logout = () => {
    auth().signOut().then(() => {
      this.setState({user: null})
    })
  }

  constructor(props) {
    super(props);
    this.state = { entries: [], exhibitionEntries: [] }; // <- set up react state

    this.formData = {};
  }

  componentWillMount() {
    /* Create reference to messages in Firebase Database */
    let entriesRef = fire.database().ref('entries').orderByKey().limitToLast(100);
    // TODO: Run once only when loaded vs every entry
    entriesRef.on('child_added', snapshot => {
      /* Update React state when message is added at Firebase Database */
      let entry = snapshot.val();
      this.setState({ entries: [entry].concat(this.state.entries) });
    })
  }

  componentDidMount() {
    auth().onAuthStateChanged(user => {
      if (user) {
        this.setState({ user })
      }
    })

    // const randomIndex = Math.floor(Math.random() * data.length);
    const randomIndex = 0;

    this.entryInfoRef.show(data[randomIndex]);
    this.mapRef.goToEntry(data[randomIndex]);
  }

  addEntry = (e) => {
    e.preventDefault(); // <- prevent form submit from reloading the page
    /* Send the message to Firebase */
    this.formData.approved = false;

    fire.database().ref('submissions').push(
      this.formData,
      (error) => {
        if (error) {
          alert("Data could not be saved." + error);
        } else {
          this.formData = {};
          this.formRef.reset();
          alert("Thank you for your submission!");
        }
      }
    );

    // this.inputEl.value = ''; // <- clear the input
  }

  render() {
    console.log('rendering');
    const { user } = this.state;

    const entries = [];
    const entryTiles = [];
    const exhibitionEntries = [];

    this.state.entries.forEach((entryData, index) => {
      entries.push(<AREntry
        data={entryData}
        key={`entry_${entryData.city}_${index}`}
      />);
    });

    dataExhibitions.forEach((entryData, index) => {
      exhibitionEntries.push(<ExhibitionEntry
        data={entryData}
        key={`entry_${entryData.name}_${index}`}
      />);
    });

    const GridView = (props) => {
      const tiles = [];

      for (let i = 0, l = props.entries.length; i < l; i += 4) {
        tiles.push(
          <AREntryTiles
            entries={props.entries.slice(i, Math.min(i + 4, l))}
            key={`entryTilesContainer_${i}`}
          />
        );
      }

      return(
        <div className="section">
          <div className="container">
            {tiles.reverse()}
          </div>
        </div>
      );
    }

    const ListView = (props) => {
      return(
        <table width="80%" align="center" className="is-fullwidth is-hoverable App-effects-table">
          <tbody>
          <tr>
            <th width="120">Scene</th>
            <th className="mobile-hide" width="170">City</th>
            <th>Where to find</th>
            <th className="mobile-hide">Directions</th>
            <th>AR Effect</th>
            <th className="mobile-hide"></th>
          </tr>
          {entries.reverse()}
          </tbody>
        </table>
      );
    }

    const ContactForm = () => {
      return(
        <form
          onSubmit={this.addEntry.bind(this)}
          ref={(ref) => {this.formRef = ref; }}
          className="App-form"
        >
          <div className="field">
            <label className="label">Facebook Profile URL *</label>
            <div className="control">
              <input className="input" type="text" required onChange={(e) => {this.formData.fbProfileUrl = e.target.value;}}/>
            </div>
          </div>
          <div className="field">
            <label className="label">Effect Name *</label>
            <div className="control">
              <input className="input" type="text" required onChange={(e) => { this.formData.location = e.target.value;}}/>
            </div>
          </div>
          <div className="field">
            <label className="label">Facebook AR Effect URL *</label>
            <div className="control">
              <input className="input" type="text" required onChange={(e) => {this.formData.effectUrl = e.target.value;}}/>
            </div>
          </div>
          <div className="field">
            <label className="label">Scene Image URL *</label>
            <div className="control">
              <input className="input" type="text" required onChange={(e) => {this.formData.imageSrc = e.target.value;}}/>
            </div>
          </div>
          <div className="field">
            <label className="label">Short Description</label>
            <div className="control">
              <textarea className="textarea" type="text" required onChange={(e) => { this.formData.description = e.target.value;}} />
            </div>
          </div>
          <div className="field">
            <label className="label">City *</label>
            <div className="control">
              <input className="input" type="text" required onChange={(e) => { this.formData.city = e.target.value;}}/>
            </div>
          </div>
          <div className="field">
            <label className="label">Country *</label>
            <div className="control">
              <input className="input" type="text" required onChange={(e) => { this.formData.country = e.target.value;}}/>
            </div>
          </div>
          <div className="field">
            <label className="label">Google Maps Location URL *</label>
            <div className="control">
              <input className="input" type="text" required onChange={(e) => { this.formData.locationUrl = e.target.value;}}/>
            </div>
          </div>
          <input type="submit" className="button is-link"/>
        </form>
      );
    }

    // fetch('https://goo.gl/maps/ymLtM9VxebQ2').then((response) => console.log(response));

    return (
      <div className="App">
        <div className="navbar">
          <div className="navbar-brand">
            <img src={logo} className="App-logo" alt="logo" />
          </div>

          <div className="navbar-end">
            <div className="navbar-item">
              <div className="App-user">
                { user ? (
                  <button onClick={this.logout} className="button">
                    Logout
                  </button>
                ) : (
                  <button onClick={this.login} className="button is-link">
                    Login with Facebook
                  </button>
                )}
                {user ? <img src={`${user.photoURL}`} className="App-user-avatar" width="30" height="30" alt="" /> : ''}
                <p className="App-username">
                  {user ? `Hi, ${user.displayName}!` : 'Hi!'}
                </p>
              </div>
              <a href="#add-entry" className="button is-link add-effect-top">Add your Effect</a>
            </div>
          </div>

        </div>
        <header className="App-header">
          <h1 className="title is-2 is-spaced">Global Directory of Facebook AR<br/>Experiences at Public Spaces</h1>
          <h2 className="subtitle is-5 is-spaced">Digitally enhance scenes together in the real world and share them with friends on Facebook</h2>
          <div className="App-video-container">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/0Aa-TN7C8Bo?start=5" frameborder="0" allow="autoplay; encrypted-media" className="App-video" allowfullscreen></iframe>
          </div>
        </header>
        <div className="App-list">
          <h2 className="title is-3 is-spaced">Discover Global Facebook AR Effects</h2>
          <h3 className="subtitle is-5 is-spaced">Visit a location listed below, launch the effect and point the camera towards the scene to enlive it.</h3>
          <div className="App-gmap">
            <Map
              data={data}
              onClick={(data) => {
                console.log(data);
                this.entryInfoRef.show(data);
                this.mapRef.goToEntry(data);
              }}
              ref={(ref) => {this.mapRef = ref}}
            />
          </div>
          <h2 className="subtitle is-6 has-text-weight-bold is-marginless">Browse the Globe for { entries.length != 0 ? entries.length : ""} Facebook AR Effects, currently selected:</h2>
          <EntryInfo ref={(ref) => this.entryInfoRef = ref}/>
        </div>
        <div className="section filter-container">
          <div className="container">
            <div className="columns is-desktop">
              <div className="column"></div>
              <div className="column is-half">
                <ul className="App-continents-list">
                  <li className="continents-list-selected">Europe</li>
                  <li>Asia</li>
                  <li>USA</li>
                  <li>Africa</li>
                  <li>Australia</li>
                </ul>
              </div>
              <div className="column">
                <ToggleView
                  onChange={(showGrid) => this.setState({showGrid})}
                />
              </div>
            </div>
          </div>
        </div>

        {this.state.showGrid && <ListView />}
        {!this.state.showGrid && <GridView entries={this.state.entries} />}

        <div className="App-exhibitions">
          <h2 className="title is-3">Global AR Exhibitions &amp; Events</h2>
          <table width="80%" align="center" className="is-fullwidth is-hoverable">
            <tbody>
            <tr>
              <th width="120">Preview</th>
              <th width="150">Event</th>
              <th className="mobile-hide" width="150">Location</th>
              <th>City, Country</th>
              <th className="mobile-hide">Date</th>
              <th className="mobile-hide">Directions</th>
              <th>Web</th>
            </tr>
            {exhibitionEntries}
            </tbody>
          </table>
        </div>

        <div className="section">
          <div className="container">
            <div className="columns">
              <div className="column"></div>
              <div className="column is-two-fifths">
                <a name="add-entry"></a>
                <ToggleButton
                  onChange={(showContent) => this.setState({showContent})}
                  title="Add your Effect"
                />
                {this.state.showContent && <ContactForm />}
                {!this.state.showContent}

              </div>
              <div className="column"></div>
            </div>
          </div>
        </div>

        <footer className="App-footer">
          © enlive 2018
        </footer>
      </div>
    );
  }

}

export default App;



// WEBPACK FOOTER //
// ./src/App.js